module.exports = __webpack_public_path__ + "img/libro-de-reclamaciones.7e095ab1.png";